import { Trans } from "react-i18next";

const News13 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##13"}
            components={{
                section: <section />,
                h3: <h3>""</h3>, // fake empty content to avoid warnings
                p: <p />,
                ul: <ul />,
                ol: <ol />,
                li: <li />,
                strong: <strong />,
                code: <code />
            }}
        />
    );
};

export { News13 };
